import { Phone, Mail, Clock, MapPin } from 'lucide-react';
import { useFetch } from '../../hooks/useFetch';
import { settingsApi } from '../../api/contentApi';
import { DynamicForm } from '../../components/forms/DynamicForm';
import { PageHero } from '../../components/ui/PageHero';
import { IconBadge } from '../../components/ui/IconBadge';
import { Seo } from '../../components/ui/Seo';
import './Contact.css';

export function Contact() {
  const { data: settings } = useFetch(() => settingsApi.public(), []);

  const coordonnees = [
    { icon: Phone, label: settings?.['contact.telephone'] },
    { icon: Mail, label: settings?.['contact.email'] },
    { icon: Clock, label: settings?.['contact.horaires'] },
    { icon: MapPin, label: settings?.['contact.adresse'] },
  ].filter((c) => c.label);

  const mapsEmbed = settings?.['maps.google_maps_embed'];
  const mapsEmbedSur = mapsEmbed?.startsWith('https://www.google.com/maps');

  return (
    <>
      <Seo
        title="Contact — AXEO Services Cergy"
        description="Contactez AXEO Services Cergy pour une demande de devis ou toute question : téléphone, email, adresse à Pontoise. Intervention à Cergy et dans toute la Communauté d'Agglomération de Cergy-Pontoise."
        path="/contact"
      />

      <PageHero
        eyebrow="Contact"
        title="Parlons de votre besoin"
        subtitle="Une question, un projet ? Écrivez-nous, nous vous répondons rapidement."
      />

      <section className="section">
        <div className="container contact__grid">
          <div className="contact__infos">
            {coordonnees.map((c) => (
              <div className="contact__info" key={c.label}>
                <IconBadge icon={c.icon} tone="primary" />
                <span>{c.label}</span>
              </div>
            ))}

            {mapsEmbedSur && (
              <iframe
                className="contact__map"
                src={mapsEmbed}
                title="Localisation"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            )}
          </div>

          <div className="contact__form">
            <DynamicForm type="contact" />
          </div>
        </div>
      </section>
    </>
  );
}
